import { render, staticRenderFns } from "./SalarySplitEditor.vue?vue&type=template&id=8129d5ec&scoped=true&"
import script from "./SalarySplitEditor.vue?vue&type=script&lang=js&"
export * from "./SalarySplitEditor.vue?vue&type=script&lang=js&"
import style0 from "./SalarySplitEditor.vue?vue&type=style&index=0&id=8129d5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8129d5ec",
  null
  
)

export default component.exports